module.exports = (__parcel__import__("1fVEF")).then(() => parcelRequire('ieIpp'));